module.exports = __webpack_public_path__ + "img/rz-theta.b6828360.svg";